module.exports = __webpack_public_path__ + "static/media/search.b0819b2d.svg";